const setFilter = (state, { payload }) => ({
  ...state,
  selectedFilterType: payload.selectedFilterType,
});

export default setFilter;
